import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=688c0366&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=688c0366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688c0366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
